import React, { Fragment } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { Button, Form, InputGroup } from "react-bootstrap";
import styles from "./styles/InputField.module.css";
import { useState } from "react";

const InputField = ({
  label,
  required,
  name,
  type,
  readonly,
  placeholder,
  value,
  onChange,
  onBlur,
  touchedValue,
  errorsValue,
  prefix,
  postfix,
  maxLength,
  note,
  className,
}) => {
  // state
  const [passwordVisible, setPasswordVisible] = useState(false);

  // variables
  let labelUI = null;
  let prefixUI = null;
  let postfixUI = null;
  let passwordEye = null;
  let noteUI = null;

  // logics before hooks

  // hooks

  // logics
  const togglePasswordVisible = () => setPasswordVisible(!passwordVisible);

  // UI partials
  if (label)
    labelUI = (
      <Form.Label className="float-left">
        {label}
        {required ? <span className="text-danger"> *</span> : null}
      </Form.Label>
    );

  if (prefix) prefixUI = <InputGroup.Text>{prefix}</InputGroup.Text>;

  if (postfix) postfixUI = <InputGroup.Text>{postfix}</InputGroup.Text>;

  if (type === "password")
    passwordEye = (
      <Button
        variant="light"
        className="border"
        onClick={togglePasswordVisible}
      >
        <i className={`bi bi-${passwordVisible ? "eye-slash" : "eye"}`} />
      </Button>
    );
  if (note)
    noteUI = (
      <span className={clsx(styles.notiText, "text-muted")}>{note}</span>
    );

  const formControl = (
    <Form.Control
      className={clsx(postfix || passwordEye ? "has-postfix" : "", className)}
      name={name}
      type={passwordVisible ? "text" : type}
      disabled={readonly}
      placeholder={placeholder}
      value={value ?? ""}
      onChange={onChange}
      onBlur={onBlur}
      isInvalid={touchedValue && errorsValue}
      maxLength={maxLength !== 0 ? maxLength : null}
      autoComplete="off"
    />
  );

  const feedback = (
    <Form.Control.Feedback type="invalid" className="text-left">
      {errorsValue}
    </Form.Control.Feedback>
  );

  // effects

  // render
  return (
    <Fragment>
      {labelUI}
      <InputGroup hasValidation>
        {prefixUI}
        {formControl}
        {passwordEye}
        {postfixUI}
        {feedback}
      </InputGroup>
      {noteUI}
    </Fragment>
  );
};

/* required: display name */
InputField.displayName = "InputField";

/* required: props types */
InputField.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  readonly: PropTypes.bool,
  placeholder: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  touchedValue: PropTypes.bool.isRequired,
  errorsValue: PropTypes.string.isRequired,
  prefix: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  postfix: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  maxLength: PropTypes.number,
  note: PropTypes.string,
};

/* required: default props */
InputField.defaultProps = {
  label: "",
  required: false,
  name: "input",
  type: "text",
  readonly: false,
  placeholder: "Enter something",
  value: "",
  onChange: () => {},
  onBlur: () => {},
  touchedValue: false,
  errorsValue: "",
  prefix: "",
  postfix: "",
  maxLength: 0,
  note: "",
};

export { InputField };
